import {Link} from 'react-router-dom'
import {observer} from 'mobx-react'
import UI from '../stores/UI'

class Sheet extends React.Component {

  constructor(props) {
    super(props)
    this.scrollPos = 0
  }

  componentDidUpdate(prevState) {
    const active = UI.page === this.props.order;
    if (active) {
      this.refs.sheet.scrollTop = 0
      window.scrollTo(0, this.scrollPos)
      window.addEventListener('scroll', this.onScroll)
    } else {
      this.refs.sheet.scrollTop = this.scrollPos
      window.removeEventListener('scroll', this.onScroll, false)
    }
  }

  onScroll = e => {
    this.scrollPos = window.pageYOffset || document.body.scrollTop
  }

  render() {

    const order = this.props.order,
          className = this.props.className,
          children = this.props.children;
    const active = UI.page === order;
    const prevPage = (UI.page - order) * (33 * UI.page) > 0;
    const x = prevPage ? (UI.page * 100) * 0.8 : UI.page * 100;
    const magnitude = 86;

    const css = {
      position: active ? 'absolute' : 'fixed',
      overflowY: active ? 'visible' : 'scroll',
      width: `${magnitude}%`,
      transform: `translateX(-${x}%)`,
      left: `${((order) * magnitude) + ((100 - magnitude) * 0.5)}vw`,
      zIndex: order * 2
    }

    return (
      <section className={`sheet-container ${active}`} style={css} ref="sheet">
        <div className={`${className} sheet`} style={{
          transform: `translateY(${active ? '0' : '52px'})`
        }}>
          {children}
        </div>
      </section>
    )
  }
}

export default observer(Sheet)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Sheet.js